import React, { useState } from 'react';

function ItemForm({ addItem }) {
  const [value, setValue] = useState('');

  function handleChange(event) {
    setValue(event.target.value);
  };

  function handleSubmit(event) {
    event.preventDefault();
    if (value) {
      addItem(value);
      setValue('');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <input type="text" className="form-control" value={value} onChange={handleChange} placeholder="Add item..." />
      </div>
      <button type="submit" className="btn btn-primary">Add item</button>
    </form>
  );
}

export default ItemForm;